import React, { useEffect } from 'react';
import { Row, Col, Card, Spin } from 'antd';
// import LineGraph from './LineGraph';
import PieGraph from './PieGraph';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart,
    Line,
    AreaChart,
    Area,
} from 'recharts';
import { usePersistedStore } from '../../store/persisted-store';
import { useReportsStore } from '../../store/slices/createReportsSlice';


export default function Graphs() {
    const { business } = usePersistedStore();
    const reports = useReportsStore()
    const data = reports.graphs.data;
    const monthData = reports.graphs.monthData;
    const loading = reports.graphs.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;


    useEffect(() => {
        // if (!token)

        // history.push('/dashboard');
        reports.getGraphsData()
        reports.getMonthsGraphsData()
    }, [token])
    // eslint-disable-line react-hooks/exhaustive-deps

    return (

        <Row gutter={[16, 16]}>
            {/* <Col span={12}>
                <Spin spinning={loading}>
                    <Card
                        size="small"
                        title="تعداد بیمه نامه های صادر شده" className="bimeh-card chart-card">
                        <LineGraph data={200} stroke="#5ec393" />
                    </Card>
                </Spin>
            </Col>
            <Col span={12}>
                <Spin spinning={loading}>
                    <Card
                        size="small"
                        title="تعداد استعلام" className="bimeh-card chart-card">
                        <LineGraph data={data.InqueryCountData} stroke="#5ec393" />
                    </Card>
                </Spin>
            </Col>*/}

            <Col span={12}>
                <Spin spinning={loading}>
                    <Card
                        size="small"
                        title=" روند بیمه نامه های صادر شده به تفکیک رشته" className="bimeh-card chart-card">
                        <div style={{ width: '100%', height: 400 }} >
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart

                                    width={800}
                                    height={800}
                                    data={monthData}
                                    direction="ltr"
                                    margin={{
                                        top: 10,
                                        right: 20,
                                        left: 20,
                                        bottom: 10,
                                    }}

                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="MnhNam" />
                                    <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
                                    <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
                                    <Tooltip />
                                    <Legend />
                                    <Bar yAxisId="left" dataKey="IssueCount" fill="#8884d8" name="صادر شده" />
                                    <Bar yAxisId="right" dataKey="PayCount" fill="#82ca9d" name="پرداخت شده" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Card>
                </Spin>
            </Col>
            <Col span={12}>
                <Spin spinning={loading}>
                    <Card
                        size="small"
                        title="بیمه نامه های صادر شده به تفکیک رشته" className="bimeh-card chart-card">
                        <PieGraph data={data && data} />
                    </Card>
                </Spin>
            </Col>
            <Col span={12}>
                <Spin spinning={loading}>
                    <Card

                        size="small"
                        title="روند بازدید صفحات به تفکیک ماه" className="bimeh-card chart-card">
                        <div style={{ width: '100%', height: 400 }} >
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart

                                    width={800}
                                    height={800}
                                    data={monthData}
                                    direction="ltr"
                                    margin={{
                                        top: 10,
                                        right: 20,
                                        left: 20,
                                        bottom: 10,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="MnhNam" name="تعداد بازدید" />
                                    <YAxis />
                                    <Tooltip />
                                    {/* <Legend /> */}
                                    <Line type="monotone" dataKey="PageLogCount" stroke="#8884d8" name="تعداد بازدید" />

                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </Card>
                </Spin>
            </Col>
            <Col span={12}>
                <Spin spinning={loading}>
                    <Card
                        size="small"
                        title="روند استعلام به تفکیک ماه" className="bimeh-card chart-card">
                        <div style={{ width: '100%', height: 400 }}  >
                            <ResponsiveContainer >
                                <AreaChart

                                    width={800}
                                    height={800}
                                    data={monthData}
                                    direction="ltr"
                                    margin={{
                                        top: 10,
                                        right: 20,
                                        left: 20,
                                        bottom: 10,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="MnhNam" />
                                    <YAxis />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="InquiryCount" stroke="#8884d8" fill="#8884d8" name="تعداد " />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </Card>
                </Spin>
            </Col>
        </Row>
    )
}